import styles from './TabBar.module.css';

export type TabKey = 'home' | 'agents' | 'games' | 'profile';

type TabItem = {
  key: TabKey;
  label: string;
  icon: JSX.Element;
};

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V21h14V9.5" />
    <path d="M9.5 21v-6h5v6" />
  </svg>
);

const AgentsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16 6.5a3 3 0 0 1 0 5" />
    <path d="M17.5 14.2A5.5 5.5 0 0 1 20.5 19" />
  </svg>
);

const GamesIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="6" width="18" height="12" rx="4" />
    <path d="M7 12h3M8.5 10.5v3" />
    <circle cx="16" cy="11" r="1" />
    <circle cx="18" cy="13.5" r="1" />
  </svg>
);

const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
  </svg>
);

const TABS: TabItem[] = [
  { key: 'home', label: '首页', icon: <HomeIcon /> },
  { key: 'agents', label: '代理', icon: <AgentsIcon /> },
  { key: 'games', label: '游戏', icon: <GamesIcon /> },
  { key: 'profile', label: '我的', icon: <ProfileIcon /> },
];

type Props = {
  active: TabKey;
  onChange: (key: TabKey) => void;
};

export const TabBar = ({ active, onChange }: Props) => (
  <nav className={styles.tabbar}>
    {TABS.map((tab) => (
      <button
        key={tab.key}
        type="button"
        className={`${styles.item} ${active === tab.key ? styles.active : ''}`}
        onClick={() => onChange(tab.key)}
      >
        <span className={styles.icon}>{tab.icon}</span>
        <span className={styles.label}>{tab.label}</span>
      </button>
    ))}
  </nav>
);
